import { createSlice } from "@reduxjs/toolkit";

const nucleoState = {
  datanucleo: []
}

export const nucleofamSlice = createSlice({
  name: "nucleofamiliar",
  initialState: nucleoState,
  reducers: {
    StoreNucleoData: (state, actions) => {
      state.datanucleo = actions.payload;
    },
    ResetNucleoData: () => nucleoState,
  }
});

export const { StoreNucleoData, ResetNucleoData } = nucleofamSlice.actions;

export default nucleofamSlice.reducer;
